import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app'
import {
  ReCaptchaV3Provider,
  initializeAppCheck,
} from 'firebase/app-check'
import {
  connectAuthEmulator,
  getAuth,
} from 'firebase/auth'
import {
  CollectionReference,
  collection,
  connectFirestoreEmulator,
  getFirestore,
} from 'firebase/firestore'
import {
  connectFunctionsEmulator,
  getFunctions,
} from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import FirestoreUser from './types/FirestoreUser'

export const productionFirebaseConfig = {
  apiKey: 'AIzaSyARFpjOM8TU3cUUumAW56YsXOVSzr4hd0E',
  authDomain: 'healing-als.firebaseapp.com',
  projectId: 'healing-als',
  storageBucket: 'healing-als.appspot.com',
  messagingSenderId: '829487775848',
  appId: '1:829487775848:web:b18436750a0b8b19083bdd',
}

export const testFirebaseConfig = {
  apiKey: 'emulator-only',
  authDomain: 'als-registry-test.firebaseapp.com',
  projectId: 'als-registry-test',
  storageBucket: 'als-registry-test.appspot.com',
  appId: 'emulator-only',
}

export const useFirebaseEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true'

if (
  process.env.NODE_ENV === 'development' &&
  !useFirebaseEmulators
) {
  throw new Error(
    'Development requires REACT_APP_USE_FIREBASE_EMULATORS=true; refusing to connect to healing-als.',
  )
}

export const firebaseConfig = useFirebaseEmulators
  ? testFirebaseConfig
  : productionFirebaseConfig

export const primaryApp: FirebaseApp = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig)

const appCheckSiteKey =
  process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY
if (process.env.NODE_ENV === 'production') {
  if (!appCheckSiteKey) {
    throw new Error(
      'Act as User requires REACT_APP_FIREBASE_APPCHECK_SITE_KEY in production.',
    )
  }
  initializeAppCheck(primaryApp, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  })
}

export const auth = getAuth(primaryApp)
export const functions = getFunctions(primaryApp)
export const firestore = getFirestore(primaryApp)
export const storage = getStorage(primaryApp)

if (useFirebaseEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', {
    disableWarnings: true,
  })
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080)
  connectStorageEmulator(storage, '127.0.0.1', 9199)
}

export const collections = {
  users: collection(
    firestore,
    'users',
  ) as CollectionReference<FirestoreUser>,
}
